"use client";

import React from "react";
import { useTranslation } from "react-i18next";
import "./AppointmentDoctorTabs.css";

export default function AppointmentDoctorTabs({
  activeTab,
  setActiveTab,
  stats = {},
}) {
  const { t } = useTranslation("appointments");

  const tabs = [
    {
      key:     "incoming",
      label:   t("tabs.incoming",  "Incoming"),
      count:   stats.incoming  ?? 0,
      color:   "blue",
    },
    {
      key:     "upcoming",
      label:   t("tabs.upcoming",  "Upcoming"),
      count:   stats.upcoming  ?? 0,
      color:   "green",
    },
    {
      key:     "completed",
      label:   t("tabs.completed", "Completed"),
      count:   stats.completed ?? 0,
      color:   "gray",
    },
    {
      key:     "cancelled",
      label:   t("tabs.cancelled", "Cancelled"),
      // ✅ Use stats.cancelled — kept in sync by updateItemStatus + reload()
      // so patient-side cancels appear here immediately
      count:   stats.cancelled ?? 0,
      color:   "red",
    },
  ];

  return (
    <div className="appointment-doctor-tabs" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          role="tab"
          aria-selected={activeTab === tab.key}
          className={[
            "appointment-doctor-tab",
            activeTab === tab.key ? "active" : "",
            `tab--${tab.color}`,
          ].filter(Boolean).join(" ")}
          onClick={() => setActiveTab(tab.key)}
        >
          <span className="tab-label">{tab.label}</span>
          {tab.count > 0 && (
            <span className="tab-count" aria-label={`${tab.count} items`}>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}